import api from './api';
import * as consts from '../../utils/constants/url';
import {prepareBookingProps} from '../../utils/helpers/booking';

const bookingApi = api.injectEndpoints({
  endpoints: build => ({
    createBooking: build.mutation({
      query(body = {}) {
        return {
          url: `/guest${consts.API_PROPERTY_VIEWING_BOOKINGS}`,
          method: 'POST',
          body,
        };
      },
    }),
    bookingById: build.query({
      query: ({id, propertyId} = {}) =>
        `/guest/property/${propertyId}${consts.API_PROPERTY_VIEWING_BOOKINGS}/${id}`,
      transformResponse: results => {
        const {data} = results;
        return {
          ...data,
          prepared: prepareBookingProps(data),
        };
      },
    }),
    confirmBooking: build.mutation({
      query({id, propertyId} = {}) {
        return {
          url: `/guest/property/${propertyId}${consts.API_PROPERTY_VIEWING_BOOKINGS}/${id}/confirm`,
          method: 'PATCH',
        };
      },
      transformErrorResponse: ({data}) => data,
      async onQueryStarted(args, {dispatch, queryFulfilled}) {
        const patch = dispatch(
          api.util.updateQueryData('bookingById', args, draft => ({
            ...draft,
            status: 'confirmed',
            prepared: {
              ...draft.prepared,
              status: 'confirmed',
              confirmable: false,
              confirmed: true,
            },
          }))
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
    cancelBooking: build.mutation({
      query({id, propertyId} = {}) {
        return {
          url: `/guest/property/${propertyId}${consts.API_PROPERTY_VIEWING_BOOKINGS}/${id}/cancel`,
          method: 'PATCH',
        };
      },
      transformErrorResponse: ({data}) => data,
      async onQueryStarted(args, {dispatch, queryFulfilled}) {
        const patch = dispatch(
          api.util.updateQueryData('bookingById', args, draft => ({
            ...draft,
            status: 'cancelled',
            prepared: {
              ...draft.prepared,
              status: 'cancelled',
              confirmable: false,
              confirmed: false,
              cancelled: true,
            },
          }))
        );
        try {
          await queryFulfilled;
        } catch {
          patch.undo();
        }
      },
    }),
  }),
});

export const {
  useCreateBookingMutation,
  useBookingByIdQuery,
  useConfirmBookingMutation,
  useCancelBookingMutation,
} = bookingApi;

export default bookingApi;
